module.exports = __webpack_public_path__ + "img/5-1_05.e8d2aec0.jpg";